import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { DeviceInfo } from "@/interface/deviceInfo";
import { ArticleState } from "@/components/ArticlePage/redux/types";

const selectArticle = (state: RootState): ArticleState => state?.article;

export default createDraftSafeSelector(selectArticle, (article: ArticleState): DeviceInfo => article.ua);
